import Kicker from './Kicker';
import SectionShell from './SectionShell';
import StatCard from './StatCard';
import { useTranslation } from 'react-i18next';

function BusinessValueSection() {
  const { t } = useTranslation();
  return (
    <SectionShell id="business-value">
      <div>
        <Kicker>{t('value.kicker')}</Kicker>
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <h2 className="text-4xl font-black leading-tight sm:text-5xl">{t('value.title')}</h2>
          <p className="text-lg leading-8 text-slate-600">
            {t('value.body')}
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2">
          <StatCard
            label={t('value.cards.feed.label')}
            value={
              <>
                -3 <span className="font-light text-[#9aa6b8]">to</span> <span className="text-emerald-500">6%</span>
              </>
            }
            description={t('value.cards.feed.desc')}
          />
          <StatCard
            label={t('value.cards.mortality.label')}
            value={
              <>
                <span className="font-light">&darr;</span> <span className="text-emerald-500">Lower</span>
              </>
            }
            description={t('value.cards.mortality.desc')}
          />
          <StatCard
            label={t('value.cards.energy.label')}
            value={<span className="text-emerald-500">Smarter</span>}
            description={t('value.cards.energy.desc')}
          />
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded bg-[rgb(16_185_129)] px-8 py-6 text-white lg:flex-row lg:items-center">
          <p className="text-xs font-extrabold uppercase text-white lg:w-72">{t('value.cards.commercial_label')}</p>
          <div className="hidden h-9 w-px bg-white/25 lg:block" />
          <p className="text-2xl font-black">
            {t('value.cards.commercial_copy')}
          </p>
        </div>
      </div>
    </SectionShell>
  );
}

export default BusinessValueSection;
